export const GET_DISCOUNTS = 'providers/settings/Discounts/GET_DISCOUNTS';
export const GET_DISCOUNTS_PAGINATION = 'providers/settings/Discounts/GET_DISCOUNTS_PAGINATION';
export const GET_DISCOUNT_DETAIL = 'providers/settings/Discounts/GET_DISCOUNT_DETAIL';
export const CREATE_DISCOUNT = 'providers/settings/Discounts/CREATE_DISCOUNT';
export const DELETE_DISCOUNT = 'providers/settings/Discounts/DELETE_DISCOUNT';
export const SET_IS_ENABLED_DISCOUNT = 'providers/settings/Discounts/SET_IS_ENABLED_DISCOUNT';
